import React, {useEffect, useState, useRef} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {Autocomplete, Button, CircularProgress, createFilterOptions, TextField} from '@mui/material';
import '../../App.css';
import '../create-json/CreateJson.css';
import useAxiosPrivate from '../../context/useAxiosPrivate';



export const CreateJson = (props) => {
  const refNamesContainer = useRef([]);
  const refInputValues = useRef([]);
  const [usersList, setUsersList] = useState([]);
  const [idList, setIdList] = useState([]);
  const [licenseKey, setLicenseKey] = useState('');
  const [json, setJson] = useState('');
  const [licenceKeysList, setLicenceKeysList] = useState([]);
  const axiosPrivate = useAxiosPrivate();

  const [openKeysList, setOpenKeysList] = useState(false);
  const loadKeysList = openKeysList && licenceKeysList.length === 0;

  const [openUsersList, setOpenUsersList] = useState(false);
  const loadUsersList = openUsersList && usersList.length === 0;

  const navigate = useNavigate();

  const [chosenUsers, setChosenUsers] = useState([]);
  const [allowDataTransfer, setAllowDataTransfer] = useState(false);
  const [factories, setFactories] = useState(null);
  const factoriesList = useRef();


  useEffect(() => {
    getFactories();
  }, []);

  useEffect(() => {
    let active = true;

    if (!loadKeysList) {
      return undefined;
    }

    (async () => {
      if (active) {
        await getData();
      }
    })();

    return () => {
      active = false;
    };
  }, [loadKeysList]);

  useEffect(() => {
    if (!openKeysList) {
      setLicenceKeysList([]);
    }
  }, [openKeysList]);


  useEffect(() => {
    let active = true;

    if (!loadUsersList) {
      return undefined;
    }

    (async () => {
      if (active) {
        await getData();
      }
    })();

    return () => {
      active = false;
    };
  }, [loadUsersList]);

  useEffect(() => {
    if (!openUsersList) {
      setUsersList([]);
    }
  }, [openUsersList]);

  const getDisabledCondition = licenseKey === null || licenseKey.trim() === '';
  const updateDisabledCondition = json === null || (typeof json === "string" && json.trim() === '')
    || refInputValues.current.length === 0;

  const getData = async () => {
    await axiosPrivate.get('/Users')
    .then((res) => {
      const data = res.data;
      const enabledOptionsTokens = data.filter(user => {
        return (!(user.deviceToken === null));
      });
      const resultTokens = enabledOptionsTokens.map(user => user.deviceToken);
      setLicenceKeysList(resultTokens);

      const enabledOptionsUsers = data.filter(user => {
        return (!(user.name === null));
      });

      const resultUsersNames = enabledOptionsUsers.map(user => {
        return user.name;
      });
      setUsersList(resultUsersNames);

      const resultIdList = enabledOptionsUsers.map(user => {
        return user.id;
      });
      setIdList(resultIdList);
    })
    .catch( (e) => { console.log("getData error ", e) } );
  };

  const getFactories = async () => {
    await axiosPrivate.get('/Users/Factory')
      .then((res) => {
        setFactories(res.data);
        console.log("factories: ", res.data)
        factoriesList.current = res.data.map(factory => `завод ${factory.factory}`)
        console.log("factories list: ", factoriesList)
      })
      .catch( (e) => { console.log("getFactories error ", e) } );
  }

  const getDataFromServer = (pathDefinition) => {
    axiosPrivate.get(`/UserAdministration/${pathDefinition}/${licenseKey}`)
      .then((res) => {
        pathDefinition === "Notification" ? setJson(res.data.content) : setJson(JSON.stringify(res.data));
      })
      .catch(e => {
        alert(JSON.stringify(e.response.data.message));
      });
  };

  const transferDataToUsers = (pathDefinition) => {
    let allRequests;
    if (pathDefinition === "Notification") {
      const newNotification = {
        title: "",
        jsonObject: json
      }
      allRequests = refInputValues.current.map((id, index) => {
        return axiosPrivate.post(`/UserAdministration/${pathDefinition}/${id}`, newNotification)
      });
    } else {
      allRequests = refInputValues.current.map((id, index) => {
        return axiosPrivate.put(`/UserAdministration/${pathDefinition}/${id}`, {"jsonObject": JSON.parse(json)})
      });
    }

    Promise.allSettled(allRequests)
      .then((res) => {
        const transferResult = res.map((user) => {
          let indexUser = null;
          for (let i = 0; i < refInputValues.current.length; i++) {
            if (user.value.data.userId === refInputValues.current[i]) {
              indexUser = i;
              break;
            }
          }
          return `\n${refNamesContainer.current[indexUser]}: ${user.value.statusText}`// value.
        });
        alert(`Result of data transfer: ${transferResult}`)
      })
      .catch(e => {
        alert(JSON.stringify(e.response))
      })
  };

  const getUsersByFactoryId = async (chosenFactoryId) => {
    console.log("chosen factory id: ", chosenFactoryId)
    await axiosPrivate.get(`/Users/GetByFactory/${chosenFactoryId}`)
      .then((res) => {
        let data = res.data;
        let newUsers = data.filter(item => {
          if (Array.isArray(item.users)) {
            return item.users
          }
        })
        let array1 = []
        let array2 = []
        newUsers.forEach((company) => {
          company.users.forEach((userObj) => {
            array1.push(userObj.id);
            array2.push(userObj.name);
          })
        })

        array1.forEach(array1Item => !refInputValues.current.includes(array1Item) && refInputValues.current.push(array1Item));
        array2.forEach(array2Item => !refNamesContainer.current.includes(array2Item) && refNamesContainer.current.push(array2Item));



        setChosenUsers(refNamesContainer.current)
        refNamesContainer.current.length > 0 ? setAllowDataTransfer(true) : setAllowDataTransfer(false)
      })
      .catch( (e) => { console.log("getUsersByFactoryId error ", e) } );
  }

  const onChangeInputUsers = (event, newValue) => {
    if (newValue.find(option => option === "Выбрать всех...")) {
      refInputValues.current = [];
      refInputValues.current = idList;
      refNamesContainer.current = [];
      usersList.forEach((value) => refNamesContainer.current.push(value));
      setChosenUsers(refNamesContainer.current);
    }
    else if (newValue.find(option => option.includes('завод'))) {
      let chosenFactoryName = newValue.find(option => option.includes('завод'));
      chosenFactoryName = chosenFactoryName.split(' ').splice(1).join(' ');
      const chosenFactory = factories.find((factory) => factory.factory === chosenFactoryName)
      getUsersByFactoryId(chosenFactory.id)
    }
    else if (newValue) {
      refNamesContainer.current = newValue;
      const matchResults = [];
      for (let i = 0; i < refNamesContainer.current.length; i++) {
        for (let j = 0; j < usersList.length; j++) {
          if (refNamesContainer.current[i] === usersList[j]) {
            matchResults[i] = idList[j];
            break
          }
        }
      }
      refInputValues.current = matchResults;
      setChosenUsers(refNamesContainer.current)
    } else {
      refNamesContainer.current = [];
    }
    refNamesContainer.current.length > 0 ? setAllowDataTransfer(true) : setAllowDataTransfer(false)
  }

  return (
    <div className='json-container'>
      <div className='control-container'>
        <div className="search-keys-wrapper">
          <Autocomplete
            className="search-keys"
            open={openKeysList}
            value={licenseKey}
            onChange={(event, newValue) => {
              setLicenseKey(newValue);
            }}
            onOpen={() => {
              setOpenKeysList(true);
            }}
            onClose={() => {
              setOpenKeysList(false);
            }}
            freeSolo
            forcePopupIcon={true}
            isOptionEqualToValue={(option, value) => option.key === value.key}
            getOptionLabel={(option) => typeof option === 'string'
            || option instanceof String ? option : ""}
            options={licenceKeysList}
            loading={loadKeysList}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Введите license key"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loadKeysList ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />
        </div>

        <div className={props.userRole.roleId > 1 ? 'app-element-off' : 'json-edit-buttons'}>
          <Button className='save-button' disabled={getDisabledCondition}
                  variant="outlined" onClick={() => getDataFromServer("Catalog")}>
            Получить Catalog
          </Button>
          <Button className='save-button' disabled={getDisabledCondition}
                  variant="outlined" onClick={() => getDataFromServer("Menu")}>
            Получить MenuList
          </Button>
          <Button className='save-button' disabled={getDisabledCondition}
                  variant="outlined" onClick={() => getDataFromServer("Bundle")}>
            Получить Bundle
          </Button>
        </div>
          <Button className='save-button' disabled={getDisabledCondition}
                  variant="outlined" onClick={() => getDataFromServer("Notification")}>
            Получить notifications
          </Button>

          <Button
            className='save-button'
            variant="outlined"
            onClick={() => {navigate('/')}}
            >
            {"Вернуться на страницу"}
          </Button>

          <Link to="/add-json/default-configuration">
            <Button
              className='save-button'
              variant="outlined"
            >
              {"Установить базовую конфигурацию"}
            </Button>
          </Link>


      </div>

      <textarea className='textarea' wrap="soft" value={json} rows="30"
        onChange={e => {setJson(e.target.value)}}></textarea>

      <div className='control-container'>
        <div className="search-users-wrapper">
          {/*<Autocomplete*/}
          {/*  multiple*/}
          {/*  disableCloseOnSelect={true}*/}
          {/*  limitTags={1}*/}
          {/*  className="search-users"*/}
          {/*  open={openUsersList}*/}
          {/*  onChange={(event, newValue) => {*/}
          {/*    if (newValue !== null) {*/}
          {/*      refNamesContainer.current = newValue;*/}
          {/*      const matchResults = [];*/}
          {/*      for (let i = 0; i < refNamesContainer.current.length; i++) {*/}
          {/*        for (let j = 0; j < usersList.length; j++) {*/}
          {/*          if (refNamesContainer.current[i] === usersList[j]) {*/}
          {/*            matchResults[i] = idList[j];*/}
          {/*            break*/}
          {/*          }*/}
          {/*        }*/}
          {/*      }*/}
          {/*      refInputValues.current = matchResults;*/}
          {/*    } else {*/}
          {/*      refNamesContainer.current = [];*/}
          {/*    }*/}
          {/*  }}*/}

          {/*  onOpen={() => {*/}
          {/*    setOpenUsersList(true);*/}
          {/*  }}*/}
          {/*  onClose={() => {*/}
          {/*    setOpenUsersList(false);*/}
          {/*  }}*/}
          {/*  freeSolo*/}
          {/*  forcePopupIcon={true}*/}
          {/*  options={usersList}*/}
          {/*  loading={loadUsersList}*/}
          {/*  renderInput={(params) => (*/}
          {/*    <TextField*/}
          {/*      {...params}*/}
          {/*      label="Введите user name"*/}
          {/*      placeholder="Users"*/}
          {/*      InputProps={{*/}
          {/*        ...params.InputProps,*/}
          {/*        endAdornment: (*/}
          {/*          <React.Fragment>*/}
          {/*            {loadUsersList ? <CircularProgress color="inherit" size={20} /> : null}*/}
          {/*            {params.InputProps.endAdornment}*/}
          {/*          </React.Fragment>*/}
          {/*        ),*/}
          {/*      }}*/}
          {/*    />*/}
          {/*  )}*/}
          {/*/>*/}


          <Autocomplete
            // disabled={!listReadyToOpen.current}
            multiple
            limitTags={3}
            // className="input-users"
            className="search-users"
            open={openUsersList}
            value={chosenUsers}  // refNamesContainer.current
            disableCloseOnSelect
            // getOptionDisabled={(option) => {
            //   return option === "Выбрать всех..." || option === "завод veon"
            // }}
            filterOptions={(options, params) => {
              const filter = createFilterOptions();
              const filtered = filter(options, params);
              // return ['Выбрать всех...', ...factoriesList, ...filtered]
              return ['Выбрать всех...', ...factoriesList.current, ...filtered]
              // else {
              //   const filter = createFilterOptions();
              //   const filtered = filter(options, params);
              //   return [...filtered]
              // }
            }}
            onChange={(e, newValue) => {
              onChangeInputUsers(e, newValue)
            }}
            onOpen={() => {
              setOpenUsersList(true);
            }}
            onClose={() => {
              setOpenUsersList(false);
            }}
            freeSolo
            forcePopupIcon={true}
            options={usersList}
            loading={loadUsersList}
            renderInput={(params) => (
              <TextField
                {...params}
                style={{fontSize : "2vw"}}
                placeholder="Получатели"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loadUsersList ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />




        </div>


        <div className={props.userRole.roleId > 1 ? 'app-element-off' : 'json-edit-buttons'}>
          <Button className='save-button' disabled={updateDisabledCondition}
                  variant="outlined" onClick={() => transferDataToUsers("Material")}>
            Отправить Catalog
          </Button>

          <Button className='save-button' disabled={updateDisabledCondition}
                  variant="outlined" onClick={() => transferDataToUsers("Menu")}>
            Отправить MenuList
          </Button>

          <Button className='save-button' disabled={updateDisabledCondition}
                  variant="outlined" onClick={() => transferDataToUsers("Bundle")}>
            Отправить Bundle
          </Button>
        </div>
        <Button className='save-button' disabled={updateDisabledCondition}
                variant="outlined" onClick={() => transferDataToUsers("Notification")}>
          Отправить notifications
        </Button>
      </div>
    </div>
  )
}
